/**
 * Calculates the greatest common divisor
 *
 * @param aVal - The first val
 * @param bVal - The second val
 * @returns - The greatest common divisor for both numbers
 */
export function greatestCommonDivisor(aVal: number, bVal: number): number {
    let aValAbs = Math.abs(aVal);
    let bValAbs = Math.abs(bVal);

    if (bValAbs > aValAbs) {
        const temp = aValAbs;
        aValAbs = bValAbs;
        bValAbs = temp;
    }
    let found: number | null = null;

    while (!found) {
        if (bValAbs === 0) {
            found = aValAbs;
        }
        aValAbs %= bValAbs;
        if (aValAbs === 0) {
            found = bValAbs;
        }
        bValAbs %= aValAbs;
    }

    return found;
}

export const gcd = greatestCommonDivisor;
